import { render, staticRenderFns } from "./UserHelpCategories.vue?vue&type=template&id=305ad718&scoped=true&"
import script from "./UserHelpCategories.vue?vue&type=script&lang=ts&"
export * from "./UserHelpCategories.vue?vue&type=script&lang=ts&"
import style0 from "./UserHelpCategories.vue?vue&type=style&index=0&id=305ad718&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305ad718",
  null
  
)

export default component.exports